module.exports = __webpack_public_path__ + "static/img/preview-02.a7ce9739.webp";